import MoorSwitch from './switch.vue';

MoorSwitch.install = Vue => Vue.component(MoorSwitch.name, MoorSwitch);

export default MoorSwitch;


// WEBPACK FOOTER //
// ./src/packages/switch/index.js